import { C } from '@angular/cdk/keycodes';
export class Constants {
  static emptyGuid = '00000000-0000-0000-0000-000000000000';

  static monthNamesAbbreviated = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  static monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  static weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
}

export const LOCID = 'LOCID';

// custom Form Perio
export const customFormPerio             = '00000039-1000-0000-0000-000000000001';
export const customFormTreatment         = '00000039-1000-0000-0000-000000000003';
export const customFormFinalReport       = '00000039-1000-0000-0000-000000000006';
export const customFormTreatmentPlanning = '00000039-1000-0000-0000-000000000007';
export const customFormRecall            = '00000039-1000-0000-0000-000000000008';
export const customFormMti               = '00000039-1000-0000-0000-000000000009';
export const customFormDiagnosis         = '00000039-1000-0000-0000-000000000010';
export const customFormTreatmentPlanApproval = '00000039-1000-0000-0000-000000000011';
export const customFormSurgicalDiagnosis   = '00000039-1000-0000-0000-000000000012';
export const customFormSurgicalTreatment   = '00000039-1000-0000-0000-000000000013';

// Landing Page Menu Tabs Ids
export const MENU_IMAGING_ID = 'b0000001-1000-0000-0000-000000000001';
export const MENU_VISIT_ID = 'b0000001-1000-0000-0000-000000000002';
export const MENU_ERX_ID = 'b0000001-1000-0000-0000-000000000003';
export const MENU_VIEW_CASE_ID = 'b0000001-1000-0000-0000-000000000004';
export const MENU_TREATMENT_PLAN_ID = 'b0000001-1000-0000-0000-000000000005';
export const MENU_INSURANCE_ID = 'b0000001-1000-0000-0000-000000000006';

// enumDocumentTag
export const DOC_TAG_PATIENT_PIC = '0000001D-1000-0000-0000-000000000001';
export const DOC_TAG_PRE_OP_1 = '0000001D-1000-0000-0000-000000000008';
export const DOC_TAG_PRE_OP_2 = '0000001D-1000-0000-0000-000000000010';
export const DOC_TAG_PRE_OP_3 = '0000001D-1000-0000-0000-000000000011';
export const DOC_TAG_PRE_OP_4 = '0000001D-1000-0000-0000-000000000012';
export const DOC_TAG_PRE_OP_5 = '0000001D-1000-0000-0000-000000000013';

export const DOC_TAGS_PRE_OP = [
  DOC_TAG_PRE_OP_1, DOC_TAG_PRE_OP_2, DOC_TAG_PRE_OP_3,
  DOC_TAG_PRE_OP_4, DOC_TAG_PRE_OP_5
];

export const DOC_TAG_POST_OP_1 = '0000001D-1000-0000-0000-000000000014';
export const DOC_TAG_POST_OP_2 = '0000001D-1000-0000-0000-000000000015';
export const DOC_TAG_POST_OP_3 = '0000001D-1000-0000-0000-000000000016';
export const DOC_TAG_POST_OP_4 = '0000001D-1000-0000-0000-000000000113';
export const DOC_TAG_POST_OP_5 = '0000001D-1000-0000-0000-000000000112';

export const DOC_TAGS_POST_OP = [
  DOC_TAG_POST_OP_1, DOC_TAG_POST_OP_2, DOC_TAG_POST_OP_3,
  DOC_TAG_POST_OP_4, DOC_TAG_POST_OP_5
];

// enumDocumentFolderType
export const DOC_FOLDER_TYPE_PATIENT = '0000001e-1000-0000-0000-000000000004';
export const DOC_FOLDER_TYPE_PATIENT_IMPORTS = '0000001e-1000-0000-0000-000000000005';
export const DOC_FOLDER_TYPE_LIBRARY = '0000001E-1000-0000-0000-000000000001';
export const DOC_FOLDER_TYPE_LECTURE = '0000001E-1000-0000-0000-000000000002';

// enumDocumentFolderRoot
export const DOC_FOLDER_ROOT_PATIENT = 'F0000001-0000-0000-0000-000000000001';
export const DOC_FOLDER_ROOT_PATIENT_IMPORTS = 'F0000001-0000-0000-0000-000000000002';
export const DOC_FOLDER_ROOT_LIBRARY = 'F0000002-0000-0000-0000-000000000001';
export const DOC_FOLDER_ROOT_LECTURE = 'F0000003-0000-0000-0000-000000000001';

// enumScheduleType
export const Patient_Will_Contact_Office = '00000511-1000-0000-0000-000000000001';
export const Contact_Patient = '00000511-1000-0000-0000-000000000002';
export const Already_Have_Appointment = '00000511-1000-0000-0000-000000000003';

// IO Tree Node IDs
export const IO_TREE_IMPORT_NODE_ID = '498ae5f2-1351-42db-9411-03232be0744d';
export const IO_TREE_CURR_PATIENT_NODE_ID = '9f65afda-bbf6-4771-a075-4405db3c32fb';
export const IO_TREE_CATS_NODE_ID = '75375340-78bd-49a2-ba46-a3a686235eff';
export const IO_TREE_CASES_NODE_ID = '6457f3d5-b902-4ad3-bb90-e5eb6dc9e8a3';
export const IO_TREE_EXAM_NODE_ID = 'a89bd30e-bd8a-4d7b-8ecc-09e0659741b6';
export const IO_TREE_NO_CAT_NODE_ID = 'a0e0ab05-171c-4113-bf4d-e4500e8f5537';
export const IO_TREE_VC_NODE_ID = '91ded364-dc80-4fc2-88d7-fcbd0693db76';

// IO Events
export const EVENT_IO_CHANGE_SIZE = 'IO_CHANGE_SIZE';
export const EVENT_IO_CHANGE_VIEW = 'IO_CHANGE_VIEW';
export const EVENT_IO_SORT = 'IO_SORT';
export const EVENT_IO_ORDER = 'IO_ORDER';
export const EVENT_IO_UPLOAD_FILE = 'IO_UPLOAD_FILE';
export const EVENT_IO_PUBLISH = 'IO_PUBLISH';
export const EVENT_IO_PUBLISH_DATA = 'IO_PUBLISH_DATA';
export const EVENT_IO_DRAW_DATA = 'IO_DRAW_DATA';
export const EVENT_IO_EDIT_COLLAGE = 'IO_EDIT_COLLAGE';

// YEXT ROUTES
export const YEXT_NAV_SUMMARY = 'insights';
export const YEXT_NAV_REPUTATION_DASH = 'reviews';
export const YEXT_NAV_SENTIMENTS = 'reviewsSentiment';
export const YEXT_NAV_CUSTOMER_ACTION = 'reports';

export const stateList: string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const DoctorType_Provider = '00000004-1000-0000-0000-000000000001';
export const DoctorType_Referring = '00000004-1000-0000-0000-000000000002';

export const ArIntegration_None = '00000539-1000-0000-0000-000000000001';
export const ArIntegration_QuickBooks = '00000539-1000-0000-0000-000000000002';


export const DiscomfortLevelList = [
  {id: 1, value: 'None'},
  {id: 2, value: 'Vague'},
  {id: 3, value: 'Mild'},
  {id: 4, value: 'Moderate'},
  {id: 5, value: 'Severe'}
];
